import {Model} from "ords/dist/model/model";

export class User extends Model {
    groupPairGroupTeacherOpenRequestsCount(option) {
        let count = 0;

        for (const group of this.group_pair_group_teachers) {
            if (option === 1 && group.group_pair_groups.check_teacher !== 2) {
                count ++;
            } else if (option === 2 && (group.group_pair_groups.check_teacher !== 2 || group.group_pair_groups.check_coordinator !== 2)) {
                count ++
            } else if (option === 3 && group.group_pair_groups.check_coordinator !== 2) {
                count ++
            }
        }

        return count;
    }
    groupPairGroupTeacherConfirmedGroupCount(option) {
        let count = 0;
        for (const group of this.group_pair_group_teachers) {
            if (option === 1 && group.group_pair_groups.check_teacher === 2) {
                count ++;
            } else if (option === 2 && group.group_pair_groups.check_teacher === 2 && group.group_pair_groups.check_coordinator === 2) {
                count ++
            } else if (option === 3 && group.group_pair_groups.check_coordinator === 2) {
                count ++
            }
        }

        return count;
    }
    groupPairGroupTeacherIsFull(option) {
        const groupPairTeacher = this.group_pair_teachers[0];
        const count = this.groupPairGroupTeacherConfirmedGroupCount(option);

        return count >= groupPairTeacher.max
    }
}

// todo zet groupPairTeacher
export const UserModelConfig = {
    name: 'user',
    model: User,
    relations: [
        {name: 'group_pair_students', model_name: 'group_pair_students', type: 'hasMany'},
        {name: 'group_pair_teachers', model_name: 'group_pair_teachers', type: 'hasMany'},
        {name: 'las_student', model_name: 'lasStudent', type: 'hasOne'},
        {name: 'group_pair_group_teachers', model_name: 'group_pair_group_teachers', type: 'hasMany'},
        {name: 'module_users', model_name: 'module_users', type: 'hasMany'},
        {name: 'rubric_survey_user', model_name: 'rubricSurveyUser', type: 'hasOne'},
        {name: 'projects', model_name: 'project', type: 'hasMany'},
        {name: 'assignment_partner_users', model_name: 'assignmentPartnerUser', type: 'hasMany'},
        {name: 'profile_image', model_name: 'profileImage', type: 'hasOne'},
        {name: 'roles', model_name: 'role', type: 'hasMany'},
        {name: 'schools', model_name: 'schools', type: 'belongsToMany'}
    ]
}
